<template>
  <div>
      <el-row style="background:#fff;">
          <div class="head clearfix">
            <el-col :xs="14" :sm="11">
              <div class="logo fl" style="display: flex; align-items: center;">
                <img class="db" style="height: 60px;width: 185px;" src="/160266137501400323578_396_88.png" alt="">
                <p class="logo-text db">毅腾国际物流园区</p>
              </div>
            </el-col>
            <el-col :xs="9" :sm="{span: 13}">
              <div class="right_nav fr" style="margin-top: 5px;">
                <ul class="nav clearfix hidden-xs-only">
                  <router-link v-for="item in routerList" :key="item.id" @click.native="navClick(item)" :class="['nav-item fl', navNative == item.id ? 'nav-item-hover' : '']" tag="li" :to="item.path">{{ item.value }}</router-link>
                  <li class="login-btn"><a style="color: #fff;" href="//login.yiteng288.com/saaslogin/index">登录</a></li>
                </ul>
                <div style="width: 31px; height: 19px;" class="hidden-sm-and-up">
                  <img style="width: 100%; height: 100%; padding-top: 15px; cursor: pointer;" src="/160267073497005186456_62_38.png" alt="">
                </div>
              </div>
            </el-col>
          </div>
      </el-row>
      <router-view></router-view>
      <el-row>
        <div class="foot">
          <div class="company-info">
            <el-row>
              <el-col class="company-info-block" :xs="24" :sm="{span: 11}">
                <h3>联系我们</h3>
                <ul>
                  <li>地址：内蒙古巴彦淖尔市乌拉特中旗甘其毛都口岸</li>
                  <li>电话：(86) 157 6487 9510 </li>
                  <li>联系人：张晶</li>
                  <li>E-Mail：zhangjing@winsway.com</li>
                </ul>
              </el-col>
              <el-col :xs="4" :sm="{span: 13, push: 2}" class="hidden-xs-only">
                <div class="clearfix contact-code-block">
                  <dl class="fl contact-code-item">
                    <dd><img src="/160266690017429145859_198_198.png" alt=""></dd>
                    <dt>易链司机</dt>
                  </dl>
                  <dl class="fl contact-code-item">
                    <dd><img src="/160266691011100479373_200_200.png" alt=""></dd>
                    <dt>易链派车</dt>
                  </dl>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="company">
            <div class="company-text">蒙ICP备2020003845号    © 2020 乌拉特中旗毅腾矿业有限责任公司 版权所有。</div>
          </div>
        </div>
      </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navNative: 1,
      routerList: [
        {
          id: 1,
          path: '/index?id=1',
          value: '首页'
        },
        {
          id: 2,
          path: '/businessIntro?id=2',
          value: '业务简介'
        },
        {
          id: 3,
          path: '/gardenIntroduction?id=3',
          value: '园区简介'
        },
        {
          id: 4,
          path: '/wisdomGarden?id=4',
          value: '智慧园区'
        },
        {
          id: 5,
          path: '/teamIntroduction?id=5',
          value: '团队介绍'
        },
      ]
    }
  },
  created() {
    this.navNative = this.$route.query.id
  },
  methods: {
    navClick(item) {
      console.log(item)
      this.navNative = item.id;
    }
  }
}
</script>

<style scpoed>
@import '../style/common.css';
.head {
  width: 1184px;
  margin: 0 auto;
  padding-top: 16px;
}
.logo {
  text-align: left;
}
.logo img {
  width: 214px;
  height: 44px;
}
.logo-text {
  color: #262634;
  font-size: 18px;
  vertical-align: bottom;
}
.nav-item {
  font-size: 18px;
  margin: 10px 15px 0px 15px;
  padding-bottom: 20px;
  border-bottom: 4px solid transparent;
  cursor: pointer;
}
.login-btn {
  display: inline-block;
  cursor: pointer;
  margin-left: 25px;
  width: 78px;
  height: 36px;
  text-align: center;
  line-height: 36px;
  margin-top: 5px;
  background: rgb(234, 87, 20);
  border-radius: 4px;
  color: rgb(255, 255, 255);
}
.nav-item:hover {
  border-bottom: 4px solid #EA5714;
  font-weight: bolder;
}
.nav-item-hover {
  border-bottom: 4px solid #EA5714;
  font-weight: bolder;
}
.foot {
  background: #26263F;
  width: 100%;
}
.company-info {
  width: 1184px;
  margin: 0 auto;
  height: 260px;
}
.contact-code-block {
  margin-top: 120px;
  display: flex;
  justify-content: flex-end;
}
.company-info-block h3 {
  text-align: left;
  color: #fff;
  padding-top: 60px;
  padding-bottom: 30px;
}
.company-info-block ul {
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
  padding-top: 10px;
  padding: 0;
}
.company-info-block li{
  text-align: left;
  padding: 3px 0;
}
.contact-code-item {
  margin-right: 57px;
}
.contact-code-item dd {
  display: inline-block
}
.contact-code-item img{
  width: 93px;
  height: 93px;
  text-align: center;
}
.contact-code-item dt {
  text-align: center;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
}
.company {
  background: #1A1A30;
  height: 60px;
  width: 100%;
}
.company-text {
  width: 1184px;
  margin: 0 auto;
  color: #9090A9;
  font-size: 13px;
  text-align: left;
  line-height: 60px;
}
</style>
